import { Store } from "redux";
import { SDK } from "@sdk";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { BrandsSlice } from "./brands.slice";
import { iBrand } from "@sdk/brands/brand-model";
import { brandsDefaultQueryConfig } from "./brands-default-query";

export const {
  loadEntityQueries: loadBrandsQuery,
  loadEntityById: loadBrandById,
  loadMoreEntityQueries: loadMoreBrandsQueries,
} = CreateHelpersForEntity<iStore, iBrand>({
  sliceName: "brands",
  slice: BrandsSlice,
  isPaginatedQueries: true,
  fetchPageSize: 25,
  loadEntityQueryProvider: (query) => SDK.brands.query(query),
  loadEntityByIdProvider: (entityId: string) => SDK.brands.getById(entityId),
});

export const LoadAllBrands = (store: Store<iStore>, forceReload?: boolean) =>
  loadBrandsQuery(brandsDefaultQueryConfig, "all")(store, forceReload);
